import { isNullOrUndefined, isUndefinedOrEmpty } from '@afterpay/utils'

export interface TargetingKeyParams {
  key: string
  merchantId?: string | number
  cohort?: string
  source?: string
  isInAppBrowser: boolean
}

export const buildTargetingKey = ({ key, merchantId, cohort, source, isInAppBrowser }: TargetingKeyParams): string => {
  const merchantIdStr = !isNullOrUndefined(merchantId) && !isUndefinedOrEmpty(String(merchantId)) ? `-${merchantId}` : ''
  const cohortStr = !isUndefinedOrEmpty(cohort) ? `-${cohort}` : ''
  const sourceStr = !isUndefinedOrEmpty(source) ? `-${source}` : ''
  const inAppBrowserStr = isInAppBrowser ? '-inApp' : ''

  return `${key}${merchantIdStr}${cohortStr}${sourceStr}${inAppBrowserStr}`
}
